<template>
  <div>
    <div id="switchAccountModal" class="switchAccModal modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content modal_wrapper">
          <div class="modal-header switchAccountModal-bgcolor">
            <div class="header-close-icon">
              <base-icon
                data-v-34da9296=""
                class="icon-close"
                icon="close_icon"
                data-toggle="modal"
                data-target="#switchAccountModal"
              ></base-icon>
            </div>
            <div class="modal-title header-props">
              <div class="col-xs-12 col-sm-12 pd-0">
                <div class="col-xs-2 col-sm-2">
                  <img
                    src="/static/images/icons/switch_account.svg"
                    alt="switch-icon"
                    class="img-size"
                  />
                </div>
                <div class="col-xs-10 col-sm-10 acc-pd">Choose Account</div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="col-xs-12 col-sm-12 switchAccount-search-input">
              <search-box v-model="searchText"></search-box>
            </div>
            <div class="col-xs-12 activity-tracker-tabs">
              <div class="containers">
                <div class="scroller scroller-left p-0" @click="leftScroll()">
                  <img
                    src="/static/images/icons/chevron_left.svg"
                    class="left-arrow cursor-pointer image-size"
                    alt=""
                  />
                </div>
                <div class="scroller scroller-right p-0" @click="rightScroll()">
                  <img
                    src="/static/images/icons/chevron_right.svg"
                    class="right-arrow cursor-pointer image-size"
                    alt=""
                  />
                </div>
                <div class="tabs-left">
                  <ul class="nav nav-tabs list" role="tablist">
                    <li
                      role="presentation"
                      class="nav-item"
                      :class="{ active: tabActiveName == 'REP' }"
                    >
                      <span class="nav-link" @click="tabClicked('REP')" role="tab" data-toggle="tab"
                        >REP</span
                      >
                    </li>
                    <li
                      role="presentation"
                      class="nav-item"
                      :class="{ active: tabActiveName == 'commercial' }"
                    >
                      <span
                        class="nav-link"
                        @click="tabClicked('commercial')"
                        role="tab"
                        data-toggle="tab"
                        >Commercial</span
                      >
                    </li>
                    <li
                      role="presentation"
                      class="nav-item"
                      :class="{ active: tabActiveName == 'consulting' }"
                    >
                      <span
                        class="nav-link"
                        @click="tabClicked('consulting')"
                        role="tab"
                        data-toggle="tab"
                        >Consulting</span
                      >
                    </li>
                    <li
                      role="presentation"
                      class="nav-item"
                      :class="{ active: tabActiveName == 'emergo' }"
                    >
                      <span
                        class="nav-link"
                        @click="tabClicked('emergo')"
                        role="tab"
                        data-toggle="tab"
                        >Emergo</span
                      >
                    </li>
                    <li
                      role="presentation"
                      class="nav-item"
                      :class="{ active: tabActiveName == 'support' }"
                    >
                      <span
                        class="nav-link"
                        @click="tabClicked('support')"
                        role="tab"
                        data-toggle="tab"
                        >Support</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ul class="col-xs-12">
              <li
                v-for="(account, indexes) in switchAccountsListToRender"
                :key="indexes"
                @click="selectedAccount(account.account_id)"
              >
                <a class="flex">
                  <div
                    class="col-xs-9 col-sm-9 default-props font-props"
                    :class="{
                      'highlight-selected': selectedAccountId === account.account_id
                    }"
                  >
                    {{ account.account_name }}
                  </div>
                  <div
                    class="col-xs-3 col-sm-3 default-none"
                    :class="{
                      'display-active': selectedAccountId === account.account_id
                    }"
                    :id="account.account_id"
                    :ref="account.account_id"
                  >
                    <img
                      src="/static/images/icons/check.svg"
                      alt="check-icon"
                      class="img-size fl-rt"
                    />
                  </div>
                </a>
                <hr class="box-int-line" />
              </li>
            </ul>
          </div>
          <div class="modal-footer switchAccountModal-bgcolor">
            <button type="button" class="col-xs-5 btn emergo-white-button" data-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              class="col-xs-5 btn ml-20 emergo-green-button"
              :disabled="selectedAccountId === ''"
              data-dismiss="modal"
              @click="switchToNewAccount()"
            >
              Go
            </button>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import { switchToNewAccount, getAccountsList } from '../../apis/login';
import Loader from '../UIComponents/Loader.vue';
import SearchBox from '../UIComponents/SearchBox.vue';

export default {
  props: ['chooseaccountsList'],
  data() {
    return {
      selectedAccountId: '',
      searchText: '',
      loaderStatus: false,
      accountsList: [],
      tabActiveName: '',
      filteredAccountsList: []
    };
  },
  components: {
    Loader,
    SearchBox
  },
  created() {},
  computed: {
    switchAccountsListToRender() {
      return this.filteredAccountsList.filter((accountObj) =>
        accountObj.account_name.toLowerCase().match(this.searchText.toLowerCase())
      );
    }
  },
  mounted() {
    $('#switchAccountModal').on('shown.bs.modal', async () => {
      this.selectedAccountId = '';
      this.tabActiveName = 'REP';
      await this.getAccountsList();
    });
    $('#switchAccountModal').on('hidden.bs.modal', async () => {
      this.tabActiveName = '';
      this.accountsList = [];
    });
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    leftScroll() {
      const scrollBarWidths = 0;
      $('.list').animate({ left: scrollBarWidths });
    },
    rightScroll() {
      const scrollBarWidths = -180;
      $('.list').animate({ left: scrollBarWidths });
    },

    async getAccountsList() {
      this.loaderStatus = true;
      const response = await getAccountsList();
      this.loaderStatus = false;
      if (response.status_code === 200) {
        this.accountsList = response.data.accounts.filter(
          (accounts) => accounts.account_id !== this.account_id
        );
        this.tabClicked('REP');
      } else {
        this.clearNotifications();
        // this.$notify({
        //   clean: true,
        // });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to fetch accounts',
          group: 'custom-notification',
          duration: -1,
          closeOnClick: true
        });
      }
    },
    tabClicked(tab) {
      switch (tab) {
        // switch (this.tabActiveName) {
        case 'emergo':
          this.filteredAccountsList = this.accountsList.filter(
            (account) => account.account_type_id === 1
          );
          break;
        case 'REP':
          this.filteredAccountsList = this.accountsList.filter(
            (account) => account.account_type_id === 2
          );
          break;
        case 'commercial':
          this.filteredAccountsList = this.accountsList.filter(
            (account) => account.account_type_id === 3
          );
          break;
        case 'consulting':
          this.filteredAccountsList = this.accountsList.filter(
            (account) => account.account_type_id === 4
          );
          break;
        case 'support':
          this.filteredAccountsList = this.accountsList.filter(
            (account) => account.account_type_id === 5
          );
          break;
        default:
          this.filteredAccountsList = this.accountsList;
      }
    },
    selectedAccount(id) {
      this.selectedAccountId = id;
    },
    resetSearch() {
      this.searchText = '';
    },
    removeStorageData() {
      socket.removeAllListeners(
        `alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`
      );
      localStorage.clear();
    },
    async switchToNewAccount() {
      const data = { target_account_id: this.selectedAccountId };
      const response = await switchToNewAccount(data);
      if (response.status) {
        this.removeStorageData();
        localStorage.setItem('roleId', response.role_id);
        localStorage.setItem('accountId', response.account_id);
        localStorage.setItem('reLoad', true);
        window.location.href = `${window.location.origin}/layout/dashboard`;
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to switch account',
          group: 'custom-notification'
        });
      }
    }
  },
  watch: {
    chooseaccountsList: {
      immediate: true,
      handler() {
        this.accountList = cloneDeep(this.chooseaccountsList);
      }
    }
  }
};
</script>
<style scoped>
.activity-tracker-tabs {
  margin-top: 25px;
}
.switchAccModal .modal-dialog {
  width: 386px;
  height: 458px;
}
.switchAccModal .modal-body {
  height: 300px;
  overflow: auto;
  padding-top: 2px;
}
.switchAccount-search-input {
  position: relative;
  float: left;
}
.switchAccount-search-input > i.fa-search {
  position: absolute;
  top: 8px;
  left: 30px;
}
.switchAccount-search-input span.search-reset {
  top: 8px;
  right: 30px;
  font-size: 17px;
}
.icon-close {
  color: #828282 !important;
  float: right;
  cursor: pointer;
}
.switchAccountModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.header-close-icon {
  font-size: 25px;
}
.font-props {
  font-family: Roboto;
  font-style: normal;
}
ul {
  list-style: none;
  margin-top: 10px;
  padding-inline-start: 0px;
}
.header-props {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  color: #0b3c61;
}
.default-props {
  line-height: 21px;
  font-size: 18px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.7);
  word-wrap: break-word;
  cursor: pointer;
  margin-left: 18px;
}
.highlight-selected {
  font-weight: 500;
  color: #0b3c61;
}
.modal-footer .btn {
  margin-left: 20px !important;
}
.img-size {
  width: 20px;
  height: 20px;
}
.fl-rt {
  float: right;
}
.box-int-line {
  height: 1px;
  margin: 10px 20px 10px 32px;
}
li:last-child > hr {
  display: none;
}
.cancel-button {
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  font-size: 16px;
}
.default-none {
  display: none;
}
.display-active {
  display: inline;
}
.search-box {
  padding: 14px 72px 14px 38px;
}
.acc-pd {
  padding: 0px 0px 0px 6px;
}
@media screen and (min-width: 568px) and (max-width: 1024px) {
  .switchAccModal .modal-dialog {
    vertical-align: top;
    margin-top: 100px;
  }
}
@media only screen and (max-width: 567px) {
  .switchAccModal .modal-dialog {
    width: 95%;
  }
}
@media (max-width: 375px) {
  .switchAccModal .modal-dialog {
    width: 90%;
  }
  .switchAccModal .modal-footer {
    padding: 0px 0px 10px 0px;
  }
  .pd-0,
  .acc-pd {
    padding: 0px;
  }
}

.tabs-left {
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  padding: 5px;
  height: 50px;
}

.list {
  position: absolute;
  left: 0px;
  top: 0px;
  min-width: 3000px;
  margin-top: 0px;
}

.list li {
  display: table-cell;
  position: relative;
  text-align: center;
  cursor: pointer;
  color: #000;
  vertical-align: middle;
}

.scroller {
  cursor: pointer;
  display: block;
  padding: 0;
  white-space: no-wrap;
  background-color: #fff;
}
.scroller.scroller-right,
.scroller.scroller-left {
  display: block;
}

.scroller-right {
  float: right;
}

.scroller-left {
  float: left;
}
.image-size {
  width: 18px;
  height: 18px;
}
li.nav-item:first-child {
  margin-left: 10px;
}
ul.nav-tabs > li {
  margin-right: 25px;
}
</style>
